<template>
    <div class="head">
        <h1 class="h1">Старт в DH</h1>
        <p class="sub">Запусти ключевые инструменты и почувствуй результат уже в первую неделю.</p>
        <div class="prog-wrap">
            <div class="prog-top">
                <span class="prog-lab">Запущено <b>{{ activeCount }} из {{ totalCount }}</b> инструментов</span>
                <span class="prog-pct">{{ progressPct }}%</span>
            </div>
            <div class="prog-track">
                <div class="prog-fill" :style="{ width: progressPct + '%' }"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StarterPackHeader',
    props: {
        activeCount: {
            type: Number,
            required: true,
        },
        totalCount: {
            type: Number,
            required: true,
        },
        progressPct: {
            type: Number,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/vars.sass';

.head {
    margin-bottom: 24px;
}

.h1 {
    margin-bottom: 9px;
    color: $dark-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 30px;
    font-weight: 900;
    line-height: 1.08;
    letter-spacing: -0.028em;
}

.sub {
    max-width: 560px;
    margin-bottom: 22px;
    color: $muted-new;
    font-size: 14.5px;
    line-height: 1.5;
}

.prog-wrap {
    display: flex;
    flex-direction: column;
    gap: 9px;
    max-width: 560px;
}

.prog-top {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
}

.prog-lab {
    color: $text-color-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 13px;
    font-weight: 600;
}

.prog-lab b {
    color: $main-new;
    font-weight: 800;
}

.prog-pct {
    color: $muted-light-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 12px;
    font-weight: 800;
}

.prog-track {
    height: 8px;
    overflow: hidden;
    background: #e7eaf1;
    border-radius: 999px;
}

.prog-fill {
    height: 100%;
    background: $main-new;
    border-radius: 999px;
    transition: width 0.55s cubic-bezier(0.4, 0, 0.2, 1);
}

@media (max-width: 760px) {
    .h1 {
        font-size: 24px;
    }
}
</style>
